import lazyWithPreload from 'react-lazy-with-preload';

export const TournamentPage = lazyWithPreload(() => import('pages/TournamentPage'));
export const HomePage = lazyWithPreload(() => import('pages/HomePage'));
export const LeaguesHomePage = lazyWithPreload(() => import('pages/LeaguesHomePage'));
export const HomePageLegacy = lazyWithPreload(() => import('pages/HomePage.legacy'));
export const LoginPage = lazyWithPreload(() => import('pages/LoginPage'));
export const NotFoundPage = lazyWithPreload(() => import('pages/NotFoundPage'));
export const SafePlayPage = lazyWithPreload(() => import('pages/SafePlayPage'));
export const LinkedTournamentsPage = lazyWithPreload(() => import('pages/linkedTournaments/LinkedTournamentsPage'));

export const EventsPanel = lazyWithPreload(() => import('components/panels/eventsSplitDraws/EventsPanel'));
export const LeagueEventsPanel = lazyWithPreload(() => import('components/panels/eventsSplitDraws/LeagueEventsPanel'));
export const MatchesPanel = lazyWithPreload(() => import('components/panels/MatchUpsPanel'));
export const ParticipantsPanel = lazyWithPreload(() => import('components/panels/ParticipantsPanel'));
export const ReportsPanel = lazyWithPreload(() => import('components/panels/ReportsPanel'));
export const ResourcesPanel = lazyWithPreload(() => import('components/panels/ResourcesPanel'));
export const SchedulePanel = lazyWithPreload(() => import('components/panels/SchedulePanel'));

export const SelectedEventPanel = lazyWithPreload(
  () => import('components/panels/eventsSplitDraws/selectedEvent/SelectedEventPanel'),
);
export const EventsTable = lazyWithPreload(() => import('components/tables/eventsSplitDraws/eventsTable/EventsTable'));

export const SplitDrawsContainer = lazyWithPreload(() => import('containers/draws/SplitDrawsContainer'));

export const ScorecardTemplateOverlay = lazyWithPreload(
  () => import('components/dialogs/scorecardTemplate/ScorecardTemplateOverlay'),
);
